'use client';

import Banana from '@cc-shopping/ui/composites/Banana';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export type ErrorProp = {
  name?: string;
  environmentName?: string;
  digest?: string;
  message: string;
};

export default function ErrorBoundary({ error, reset }: { error: ErrorProp; reset: () => void }) {
  useEffect(() => {
    if (error) {
      datadogRum.addError(error, { message: 'Fatal error triggered root client error boundary' });
    }
  }, [error]);
  return <Banana reset={reset} />;
}
